import React from "react";

import {OgImage} from "../../../opengraph/components/OgImage";
import {PropsValidator} from "../../../opengraph/utils/ogPathMap";

/**
 * @param root should be passed from `getHtml`
 */
type Props = {
  root?: string;
};

export const propsValidator: PropsValidator = (): true => true;

const DefaultOg = ({root = "https://carbonhealth.com"}: Props): JSX.Element => (
  <OgImage root={root}>
    <div className="df h100p w100p aic jcc bg-darkerMint">
      <div className="ph20 pb40 pt18 df fdc aic jcc">
        <img className="mb20" src={`${root}/static/img/v5/logo-white.svg`} alt="" width={300} />
        <h1 className="font-csb maxw50 white fs60 tac pos-r">
          Making{" "}
          <span className="pos-r">
            good health
            <img
              className="pos-a right0 left0 ma"
              width="280px"
              height="18px"
              style={{
                bottom: -2,
                opacity: 0.6,
                filter: "grayscale(30%) hue-rotate(-20deg)",
                transform: "rotate(-0.5deg)",
              }}
              src={`${root}/static/img/v5/home/word-yellow-underline.jpg`}
              alt=""
            />
          </span>{" "}
          accessible to everyone
          <img
            className="pos-a"
            width="100px"
            style={{
              bottom: -50,
              right: 70,
              opacity: 0.6,
              transform: "rotate(230deg)",
              filter: "brightness(140%) saturate(200%)",
            }}
            src={`${root}/static/img/v5/illustrated-arrow-purple.jpg`}
            alt=""
          />
        </h1>
      </div>
    </div>
  </OgImage>
);

export default DefaultOg;
